__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__hL5KSq__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__hL5KSq__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__hL5KSq__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__hL5KSq__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__hL5KSq__back-top-wrap",
  "cardlist": "index-module-scss-module__hL5KSq__cardlist",
  "filterTableSelect": "index-module-scss-module__hL5KSq__filterTableSelect",
  "grid": "index-module-scss-module__hL5KSq__grid",
  "loading": "index-module-scss-module__hL5KSq__loading",
  "pagination": "index-module-scss-module__hL5KSq__pagination",
  "skeletonCard": "index-module-scss-module__hL5KSq__skeletonCard",
  "skeletonContent": "index-module-scss-module__hL5KSq__skeletonContent",
  "skeletonMeta": "index-module-scss-module__hL5KSq__skeletonMeta",
  "skeletonThumbnail": "index-module-scss-module__hL5KSq__skeletonThumbnail",
  "skeletonTitle": "index-module-scss-module__hL5KSq__skeletonTitle",
});
